// Gem banner: random gem button and the gem quiz (sections/gs-gem-banner.liquid).
(() => {
  const readGems = (root) => {
    const el = root.querySelector('script[data-gs-gems]');
    try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; }
  };
  const pick = (list) => list[Math.floor(Math.random() * list.length)];

  // "Results" lines look like "1121 = cristal-de-cuarzo | cuarzo-rosa".
  const parseResults = (text) => {
    const map = {};
    (text || '').split(/\r?\n/).forEach((line) => {
      const [key, value] = line.split('=');
      if (!key || !value) return;
      const handles = value.split('|').map((h) => h.trim()).filter(Boolean);
      if (handles.length) map[key.trim()] = handles;
    });
    return map;
  };

  document.querySelectorAll('.gs-gem-banner').forEach((section) => {
    const gems = readGems(section);
    const handles = Object.keys(gems);
    section.querySelectorAll('[data-random-gem]').forEach((link) => {
      if (handles.length) link.href = gems[pick(handles)].url;
    });
  });

  if (customElements.get('gs-gem-quiz')) return;
  customElements.define('gs-gem-quiz', class extends HTMLElement {
    connectedCallback() {
      this.gems = readGems(this.closest('.gs-gem-banner') || document);
      this.results = parseResults(this.dataset.results);
      this.steps = [...this.querySelectorAll('.gs-gem-quiz__step')];
      this.result = this.querySelector('.gs-gem-quiz__result');
      this.answers = [];
      this.addEventListener('click', (event) => {
        const answer = event.target.closest('[data-answer]');
        if (answer) this.choose(answer.dataset.answer);
        else if (event.target.closest('.gs-gem-quiz__again')) this.show(0, []);
      });
    }

    show(index, answers) {
      this.answers = answers;
      this.steps.forEach((step, i) => { step.hidden = i !== index; });
      this.result.hidden = index < this.steps.length;
      const visible = index < this.steps.length ? this.steps[index] : this.result;
      const focusable = visible.querySelector('button, a');
      if (focusable && answers.length) focusable.focus({ preventScroll: true });
    }

    choose(answer) {
      const answers = [...this.answers, answer];
      if (answers.length < this.steps.length) return this.show(answers.length, answers);
      const handles = (this.results[answers.join('')] || []).filter((h) => this.gems[h]);
      const handle = handles.length ? pick(handles) : pick(Object.keys(this.gems));
      const gem = this.gems[handle];
      if (!gem) return;
      this.querySelectorAll('[data-gem-name]').forEach((el) => { el.textContent = gem.name; });
      this.querySelector('[data-gem-sign]').textContent = gem.sign || '';
      this.querySelector('[data-gem-link]').href = gem.url;
      this.show(this.steps.length, answers);
    }
  });
})();
